import { Link } from 'react-router-dom';
import PageShell from '../../../components/layout/PageShell';

// ✅ Custom breadcrumbs example:
// const crumbs = [
//   { label: 'Home', to: '/' },
//   { label: 'Community', to: `/community/${communityId}` },
//   { label: 'Match Manager', to: `/community/${communityId}/match-manager/${managerId}` },
//   { label: 'Manual Match Format' },
// ];
// <PageShell breadcrumbs={crumbs}>...</PageShell>
// <PageShell breadcrumbOverrides={{ tournamentId: tournament?.name || 'Tournament' }}>
function LaunchPage() {
  return (
    <PageShell containerClassName="p-0">
    <div className="launch-page py-5">
      <div className="container">
        <section className="launch-hero card border-0 shadow-lg overflow-hidden mb-4">
          <div className="card-body p-4 p-lg-5 d-flex flex-column gap-4">
            <div className="d-flex flex-wrap align-items-center gap-2">
              <span className="launch-tag">Launching tomorrow</span>
              <span className="badge text-bg-warning">Beta</span>
            </div>
            <div className="d-flex flex-column gap-3">
              <h1 className="display-5 fw-bold mb-0 text-white">
                CrickArena is ready for its first public beta.
              </h1>
              <p className="lead text-white-50 mb-0">
                Share this page with your club, community, or organization today. We launch tomorrow with
                faster player onboarding, smarter match management, and the tournament tools you asked for.
              </p>
            </div>
            <div className="d-flex flex-wrap gap-3">
              <Link className="btn btn-light btn-lg" to="/auth/register">
                Join the beta
              </Link>
              <Link className="btn btn-outline-light btn-lg" to="/login">
                Sign in
              </Link>
            </div>
            <div className="launch-hero__meta text-white-50">
              <div>
                <span className="fw-semibold text-white">Launch window:</span> Tomorrow at 10:00 AM IST
              </div>
              <div>
                <span className="fw-semibold text-white">Support:</span> Concierge onboarding available during beta
              </div>
            </div>
          </div>
        </section>

        <section className="launch-section mb-4">
          <div className="row g-4">
            {[
              {
                title: 'One place for every roster',
                copy: 'Centralize player profiles, roles, and availability so captains always have the latest squad view.',
              },
              {
                title: 'Match rooms that stay live',
                copy: 'Keep fixtures, scorecards, and announcements in sync as you move from scheduling to match day.',
              },
              {
                title: 'Tournament-ready from day one',
                copy: 'Spin up brackets, auctions, and leaderboards with dashboards that scale from 6 teams to 60.',
              },
            ].map((item) => (
              <div className="col-12 col-lg-4" key={item.title}>
                <div className="launch-card card h-100 border-0">
                  <div className="card-body p-4">
                    <h3 className="h5 fw-semibold">{item.title}</h3>
                    <p className="text-muted mb-0">{item.copy}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="launch-section mb-4">
          <div className="row g-4">
            <div className="col-12 col-lg-6">
              <div className="launch-card card h-100 border-0">
                <div className="card-body p-4">
                  <h2 className="h4 fw-semibold mb-3">Beta rollout timeline</h2>
                  <ul className="timeline list-unstyled mb-0">
                    <li>
                      <span className="timeline-date">Today</span>
                      <p className="mb-0">Share the launch page and collect early access interest.</p>
                    </li>
                    <li>
                      <span className="timeline-date">Tomorrow</span>
                      <p className="mb-0">Beta accounts open with onboarding for organizations and communities.</p>
                    </li>
                    <li>
                      <span className="timeline-date">Next 30 days</span>
                      <p className="mb-0">Weekly updates covering auctions, live scoring, and admin tooling.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="launch-card card h-100 border-0">
                <div className="card-body p-4">
                  <h2 className="h4 fw-semibold mb-3">What you get in beta</h2>
                  <ul className="list-unstyled mb-0">
                    {[
                      'Priority setup for your first tournament.',
                      'Direct access to our product team for feedback.',
                      'Early feature flags for auctions and live scoring.',
                      'A white-glove migration plan for existing data.',
                    ].map((item) => (
                      <li className="d-flex align-items-start gap-2" key={item}>
                        <span className="launch-bullet" aria-hidden="true">✓</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="launch-cta text-center">
          <div className="launch-card card border-0 shadow-sm">
            <div className="card-body p-4 p-lg-5">
              <h2 className="h3 fw-semibold mb-3">Ready to bring your league onboard?</h2>
              <p className="text-muted mb-4">
                Register today to reserve a beta slot, or share this page with your leadership team.
                We will reach out with onboarding and match setup guidance within 24 hours of launch.
              </p>
              <div className="d-flex flex-wrap justify-content-center gap-3">
                <Link className="btn btn-primary btn-lg" to="/auth/register">
                  Reserve a beta slot
                </Link>
                <a className="btn btn-outline-secondary btn-lg" href="mailto:hello@crickarena.com">
                  Contact us
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  
    </PageShell>
  );
}

export default LaunchPage;
